import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { SubmitEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsFormTechnicalVisitApi extends ComponentAPI<any> {

  /** @event */
  @AwesomeEvent
  onSubmit = new SubmitEventListener();

  setEditing(editing: boolean): void {
    this.setState({ editing: editing, locked: !editing, disabled: !editing });
  }

  setLocked(locked: boolean): void {
    this.setState({ locked: locked, disabled: locked });
  }

}
